<template>
	<div
		class="media-view-container ph-no-capture"
		:class="{
			'edit-view': edit,
			file: media.isFile,
			'meetings-preview': meetings && loading,
			audio: media.isAudio,
			'photo-video': media.isVisual,
		}"
	>
		<AudioPlayer
			v-if="media.isAudio"
			:src="media.mediaUrl"
			:duration="media.duration"
			:loading="loading"
			:percent="percent"
		/>
		<MediaFile
			v-if="media.isFile"
			:media="media"
			:loading="loading"
			:disabled="disabled"
		/>
		<VisualMedia
			v-if="media.isVisual"
			:class="{ 'edit-width': edit, 'media-thumbnail': thumbnail }"
			:isSent="!loading"
			:media="media"
			rounded
			openOnClick
		/>
	</div>
</template>

<script>
import store from '@/store'
import VisualMedia from '@/components/common/VisualMedia'
import MediaFile from './MediaFile'
import AudioPlayer from './AudioPlayer'

export default {
	props: {
		media: null,
		edit: null,
		thumbnail: null,
		meetings: null,
		loading: null,
		disabled: null,
	},
	components: { VisualMedia, MediaFile, AudioPlayer },
	data() {
		return {
			store,
			isFile: false,
			isVideo: false,
			percent: 0,
		}
	},
	watch: {
		'media.uploadProgressPct': {
			handler(pct) {
				this.percent = pct
			},
			deep: true,
		},
	},
}
</script>

<style lang="scss" scoped>
.meetings-preview :deep(.image-preview-shaded) {
	margin-left: unset;
	position: unset;
	left: unset;
}

.meetings-preview :deep(.image-preview-loader) {
	margin-top: unset;
	margin-left: unset;
	position: absolute;
	top: 55px;
	left: 58px;
}

.meetings-preview .image-preview-shaded,
.meetings-preview .video-preview-shaded {
	left: 0 !important;
}

.meetings-preview .video-preview-shaded {
	width: 238px !important;
}

.meetings-preview .video-preview-loader {
	margin-left: 105px !important;
}

.meetings-preview .attachment-preview-wrapper {
	left: unset !important;
	right: 5px !important;
	top: 0 !important;
}

.meetings-preview .attachment-preview-loader {
	margin-top: 2px !important;
}

.media-view-container {
	position: relative;
}

.edit-view {
	margin-right: 20px;
}

.edit-width {
	width: 100%;
}

.pointer {
	cursor: pointer;
}

.media-image,
.media-video {
	margin-top: 10px;
	width: 50%;
	height: auto;
}

.media-thumbnail {
	height: 36px;
	width: 48px;
	object-fit: cover;
	border-radius: 5px;
}

.delete-announcement-image {
	top: 0;
	right: -5px;
}

.delete-announcement-image-rotation {
	top: -15px;
	right: 177px;
}

.delete-announcement-video {
	top: 0;
	left: unset;
	right: 12px;
}

.delete-announcement-attachment {
	top: -10px;
	left: 487px;
}

.announcement-image-rotation {
	margin-top: 80px;
	margin-left: -83px;
}

.sending {
	opacity: 0.5;
}

:deep(.attachment-preview-wrapper) .preview-spinner:before {
	height: 15px;
	width: 15px;
}

:deep(.attachment-preview-wrapper) .preview-spinner {
	height: 15px;
	width: 15px;
}
</style>
